import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Landing from "./components/landing";
import Auth from "./components/auth";
import Footer from "./components/footer";
import NavDrawer from "./components/navDrawer";
import QuickAssessor from "./components/quickAssessor";
import Dashboard from "./components/dashboard";
import Search from "./components/search";
import Settings from "./components/settings";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Typography,
  Snackbar,
} from "@mui/material";
import Loading from "./components/loading";
import { refreshTokenService } from "./services/refreshService";
import { getUserService } from "./services/loginService";
import { Box } from "@mui/system";
import { login, logout, setUserData } from "./features/authSlice";
import NewUser from "./components/newUser";
import { HandleLogin } from "./components/handleLogin";
import ImportPage from "./components/importPage";
import ReportsPage from "./components/reportsPage";

function App() {
  const loggedIn = useSelector((state) => state.auth.value.accessToken);
  const snackbar = useSelector((state) => state.snackbar.value);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    async function refresh() {
      const res = await refreshTokenService();
      if (res?.ok) {
        dispatch(login({ accessToken: res.accessToken, admin: res.admin }));
        // Load the user record (incl. per-CID write permissions) for UI gating.
        const user = await getUserService();
        if (user) {
          dispatch(setUserData(user));
        }
      } else {
        navigate("/auth", { replace: true });
        dispatch(logout());
      }
    }
    refresh();
  }, [dispatch, navigate]);

  let protectedRoutes = [
    <Route key={0} path="/app" element={<NavDrawer />} />,
    <Route
      key={1}
      path="/app/search"
      element={
        <>
          <NavDrawer />
          <Search />
        </>
      }
    />,
    <Route
      key={8}
      path="/app/contacts"
      element={<Navigate to="/app/search" replace />}
    />,
    <Route
      key={2}
      path="/app/dashboard"
      element={
        <>
          <NavDrawer />
          <Dashboard />
        </>
      }
    />,
    <Route
      key={3}
      path="/app/quickAssessor"
      element={
        <>
          <NavDrawer />
          <QuickAssessor />
        </>
      }
    />,
    <Route
      key={9}
      path="/app/reports"
      element={
        <>
          <NavDrawer />
          <ReportsPage />
        </>
      }
    />,
    <Route
      key={10}
      path="/app/import"
      element={
        <>
          <NavDrawer />
          <ImportPage />
        </>
      }
    />,

    <Route
      key={4}
      path="/app/newUser"
      element={
        <>
          <NavDrawer />
          <NewUser />
        </>
      }
    />,
    <Route
      key={5}
      path="/app/properties"
      element={<Navigate to="/app/search" replace />}
    />,
    <Route
      key={6}
      path="/app/settings"
      element={
        <>
          <NavDrawer />
          <Settings />
        </>
      }
    />,
    <Route
      key={7}
      path="/app/admin"
      element={<Navigate to="/app/settings" replace />}
    />,
  ];

  return (
    <Box
      sx={{
        backgroundImage: `linear-gradient(to top left, rgba(0, 38, 255, .07), #f6f8fc 55%)`,
        minHeight: "100vh",
      }}
    >
      <Snackbar
        open={snackbar.open}
        autoHideDuration={1000}
        message={snackbar.message}
      />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login/:token" element={<HandleLogin />} />
        <Route path="/auth" element={<Auth />} />
        {loggedIn ? (
          protectedRoutes.map((r) => {
            return r;
          })
        ) : (
          <Route path="/app/*" element={<Loading />} />
        )}
        <Route
          path="/*"
          element={
            <Typography variant="h5" textAlign="center" sx={{ mt: 1 }}>
              404 Error Not Found
            </Typography>
          }
        />
        <Route
          path="/error"
          element={
            <Typography variant="h5" textAlign="center" sx={{ mt: 1 }}>
              An Error Occured
            </Typography>
          }
        />
      </Routes>
      <Footer />
    </Box>
  );
}

export default App;
